"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _DateiBase = _interopRequireDefault(require("./DateiBase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The BeitragBase model module.
 * @module model/BeitragBase
 * @version 0.0.1
 */
class BeitragBase {
  /**
   * Constructs a new <code>BeitragBase</code>.
   * @alias module:model/BeitragBase
   * @param titel {String} 
   * @param body {String} 
   */
  constructor(titel, body) {
    BeitragBase.initialize(this, titel, body);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, titel, body) {
    obj['titel'] = titel;
    obj['body'] = body;
  }

  /**
   * Constructs a <code>BeitragBase</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/BeitragBase} obj Optional instance to populate.
   * @return {module:model/BeitragBase} The populated <code>BeitragBase</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new BeitragBase();
      if (data.hasOwnProperty('titel')) {
        obj['titel'] = _ApiClient.default.convertToType(data['titel'], 'String');
      }
      if (data.hasOwnProperty('body')) {
        obj['body'] = _ApiClient.default.convertToType(data['body'], 'String');
      }
      if (data.hasOwnProperty('bild')) {
        obj['bild'] = _DateiBase.default.constructFromObject(data['bild']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>BeitragBase</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BeitragBase</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of BeitragBase.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['titel'] && !(typeof data['titel'] === 'string' || data['titel'] instanceof String)) {
      throw new Error("Expected the field `titel` to be a primitive type in the JSON string but got " + data['titel']);
    }
    // ensure the json data is a string
    if (data['body'] && !(typeof data['body'] === 'string' || data['body'] instanceof String)) {
      throw new Error("Expected the field `body` to be a primitive type in the JSON string but got " + data['body']);
    }
    // validate the optional field `bild`
    if (data['bild']) {
      // data not null
      _DateiBase.default.validateJSON(data['bild']);
    }
    return true;
  }
}
BeitragBase.RequiredProperties = ["titel", "body"];

/**
 * @member {String} titel
 */
BeitragBase.prototype['titel'] = undefined;

/**
 * @member {String} body
 */
BeitragBase.prototype['body'] = undefined;

/**
 * @member {module:model/DateiBase} bild
 */
BeitragBase.prototype['bild'] = undefined;
var _default = exports.default = BeitragBase;